/**
 * LayerControl
 *
 * Checkbox toggles for map layers: USGS Topo, Satellite, County Boundaries,
 * and MGRS Grid. State is managed externally via props.
 */

import React from 'react'

const LAYER_LABELS = {
  topo: 'USGS Topo',
  satellite: 'Satellite Imagery',
  counties: 'County Boundaries',
  mgrsGrid: 'MGRS Grid',
}

/**
 * @param {{
 *   layers: { topo: boolean, satellite: boolean, counties: boolean, mgrsGrid: boolean },
 *   onToggle: (layerKey: string) => void
 * }} props
 */
export function LayerControl({ layers, onToggle }) {
  return (
    <div className="layer-control leaflet-control-layers leaflet-control-layers-expanded">
      <div className="leaflet-control-layers-list">
        {Object.entries(LAYER_LABELS).map(([key, label]) => (
          <label key={key} className="leaflet-control-layers-label">
            <input
              type="checkbox"
              className="leaflet-control-layers-selector"
              checked={!!layers[key]}
              onChange={() => onToggle(key)}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default LayerControl
